import BookFremvisningPopup from "./BookFremvisningPopup";

export default BookFremvisningPopup;
